import React, { useState, useEffect } from 'react';
import GlobalContext from './GlobalContext';

import phpVars from 'phpVars';

const GlobalProvider = (props) =>
{
    useEffect(() => {
    }, []);

    return (
        <GlobalContext.Provider
            value={{
                user_name: phpVars.user_name,
                user_org: phpVars.user_org,
                userType : phpVars.user_type,
                isEditor : phpVars.is_editor,
                isManager : phpVars.is_manager,
                setHeader: ( text ) =>
                {
                    setHeader ( text );
                }

            }}
        >
        {props.children}
        </GlobalContext.Provider>
    )
}

export default GlobalProvider;